import type { IBsiCardDeletionTask, IBsiCardLimitModificationTask } from '../../api/domain';
import { ProcessEngineTask } from '../../enum';
import type { IRootState } from '../root-reducer';

export const getBsiCases = (state: IRootState) => state.processEngineApi.bsiCases;
const getBsiCasesByTaskType = (state: IRootState, taskType: ProcessEngineTask) => state.processEngineApi.bsiCases.filter((bc) => bc.taskType === taskType);
export const getBsiCardLimitModificationTasks = (state: IRootState) =>
    getBsiCasesByTaskType(state, ProcessEngineTask.MODIFY_CARD_LIMIT) as IBsiCardLimitModificationTask[];
export const getBsiCardDeletionTasks = (state: IRootState) => getBsiCasesByTaskType(state, ProcessEngineTask.DELETE_CARD) as IBsiCardDeletionTask[];
export const getBsiPopupNotifications = (state: IRootState) => {
    const selectedPopup = state.processEngineApi.bsiPopupSelected;
    if (selectedPopup) {
        // Make sure that the selected notification is always the first message we see, the rest follows based on the insertion order
        const bsiPopupResponsesCopy = { ...state.processEngineApi.bsiPopupResponses };
        const selectedPopupNotification = bsiPopupResponsesCopy[selectedPopup.kdLnr].popupResponses.find((it) => it.id === selectedPopup.popupId);
        const filteredPopupNotifications = bsiPopupResponsesCopy[selectedPopup.kdLnr].popupResponses.filter((it) => it.id !== selectedPopup.popupId);
        bsiPopupResponsesCopy[selectedPopup.kdLnr] = { popupResponses: [selectedPopupNotification!, ...filteredPopupNotifications] };

        return bsiPopupResponsesCopy;
    }

    return state.processEngineApi.bsiPopupResponses;
};
